import { ICustomField } from "../interfaces";

const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || "";

function getToken() {
  return localStorage.getItem("thackd_jwt");
}

export function removeToken() {
  localStorage.removeItem("thackd_jwt");
}

function fetchData(url: string, headers: any | null) {
  if (!headers) {
    headers = {};
  }

  return fetch(url, { headers: headers }).then((response) => response.json());
}

function postData(url: string, data: any, headers: any) {
  if (!headers) {
    headers = {
      "Content-Type": "application/json",
    };
  } else {
    headers = {
      ...headers,
      "Content-Type": "application/json",
    };
  }

  return fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  });
}

export function login(email: string, password: string) {
  email = email.toLowerCase();
  return postData(SERVER_DOMAIN + "/api/token/", { email, password }, null);
}

export function signUp(email: string, password: string, profileId: string) {
  return postData(
    SERVER_DOMAIN + "/api/create-user/",
    { email, password, pid: profileId },
    null,
  );
}

export function getUser() {
  const token = getToken();
  if (token) {
    return fetchData(SERVER_DOMAIN + "/api/get-user/", {
      Authorization: `Bearer ${token}`,
    });
  } else {
    return false;
  }
}

export function getProfile(profileId: string) {
  return fetchData(SERVER_DOMAIN + `/api/get-profile/${profileId}/`, null);
}

export async function checkUserExists(email: string) {
  const response = await postData(
    SERVER_DOMAIN + "/api/check-user-exists/",
    { email },
    null,
  );
  const data = await response.json();
  return { email: data.email, isLegacy: data.isLegacy };
}

export function postCheckout(
  itemKey: string,
  product: "ASANA" | "MONDAY" | "PROFANITY_FILTER",
  volumeLimit: number,
  profileId: string | null,
) {
  if (profileId) {
    // This is for Asana
    return postData(
      SERVER_DOMAIN + "/api/create-checkout-session/",
      {
        itemKey,
        product,
        volumeLimit,
        profileId,
      },
      null,
    );
  } else {
    // This is for profanity filter
    const token = getToken();
    return postData(
      SERVER_DOMAIN + "/api/create-checkout-session/",
      {
        itemKey,
        product,
        volumeLimit,
      },
      { Authorization: `Bearer ${token}` },
    );
  }
}

export function getManageSubscriptionURL() {
  const token = getToken();
  return fetchData(SERVER_DOMAIN + "/api/create-portal-session/", {
    Authorization: `Bearer ${token}`,
  });
}

export function orderSuccess(sessionId: string, profileId: string | null) {
  if (profileId) {
    return postData(
      SERVER_DOMAIN + "/api/order-success/",
      {
        sessionId,
        profileId,
      },
      null,
    );
  } else {
    const token = getToken();
    return postData(
      SERVER_DOMAIN + "/api/order-success/",
      {
        sessionId,
      },
      { Authorization: `Bearer ${token}` },
    );
  }
}

export function resetPassword(email: string) {
  return postData(SERVER_DOMAIN + "/api/reset-password/", { email }, null);
}

export function getIntercomWorkspace(profileId: string) {
  return fetchData(
    SERVER_DOMAIN + `/api/get-intercom-workspace?profileId=${profileId}`,
    null,
  );
}

type CsShieldStatsType = {
  num_images_checked: number;
  num_images_censored: number;
  num_conversation_parts_checked: number;
  num_conversation_parts_censored: number;
};

export function getCSShieldStats(userId: string): Promise<CsShieldStatsType> {
  const token = getToken();
  return fetchData(SERVER_DOMAIN + `/api/get-cs-shield-stats/${userId}/`, {
    Authorization: `Bearer ${token}`,
  });
}

export function getAttributesList(profileId: string) {
  return fetchData(
    SERVER_DOMAIN + `/api/get-attributes-list/${profileId}/`,
    null,
  );
}

export function getAvailableAttributesList(profileId: string) {
  return fetchData(
    SERVER_DOMAIN + `/api/get-available-attributes-list/${profileId}/`,
    null,
  );
}

export function postSaveAttributesList(
  attributesList: string[],
  profileId: string,
) {
  return postData(
    SERVER_DOMAIN + `/api/save-attributes-list/${profileId}/`,
    {
      attributesList,
    },
    null,
  );
}

export function getCustomFieldList(profileId: string) {
  return fetchData(
    SERVER_DOMAIN + `/api/get-custom-fields/${profileId}/`,
    null,
  );
}

export function postSaveCustomFields(
  customFieldsList: ICustomField[],
  profileId: string,
) {
  return postData(
    SERVER_DOMAIN + `/api/save-custom-fields/${profileId}/`,
    {
      customFieldsList,
    },
    null,
  );
}

export function getAsanaCustomFieldList(query: string, profileId: string) {
  return fetchData(
    SERVER_DOMAIN + `/api/get-asana-custom-fields/${profileId}?query=${query}`,
    null,
  );
}
